import {HStack, Show, Text, VStack} from 'platform/foundation';

import {isNotEmpty} from 'ramda';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {DashboardHiddenTile} from '../../types/DashboardHiddenTile';
import {DashboardTileId} from '../../types/DashboardTileId';
import {DashboardHiddenTilePreview} from './components/DashboardHiddenTilePreview';
import {renderDashboardTilePreview} from './utils/renderDashboardTilePreview';

interface DashboardHiddenTilesProps extends TestIdProps {
  tiles: DashboardHiddenTile[];
  isCustomising: boolean;
  onShow: (id: DashboardTileId) => void;
}

export function DashboardHiddenTiles(props: DashboardHiddenTilesProps) {
  return (
    <Show when={props.isCustomising && isNotEmpty(props.tiles)}>
      <VStack spacing={2} data-testid={suffixTestId('hiddenTiles', props)}>
        <Text size="small" color="secondary">
          {i18n.t('page.homepage.dashboardLayout.hiddenWidgets')}
        </Text>
        <HStack spacing={4} wrap>
          {props.tiles.map((tile) => (
            <DashboardHiddenTilePreview
              key={tile.id}
              tile={tile}
              onShow={props.onShow}
              data-testid={props['data-testid']}
            >
              {renderDashboardTilePreview(tile)}
            </DashboardHiddenTilePreview>
          ))}
        </HStack>
      </VStack>
    </Show>
  );
}
